'use client';

import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="w-full border-t border-[var(--line)] dark:border-[var(--line)] relative z-10">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-[var(--text)] text-[var(--font-size-sm)] leading-none text-sharp text-center sm:text-left">
            © {new Date().getFullYear()} Vivekanand Pandey | All rights reserved.
          </span>
          <div className="flex items-center gap-4 relative z-20">
            <Link
              href="https://github.com/itsvnp"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--text)] hover:text-[var(--accent-color)] dark:hover:text-[var(--accent-color)] transition-colors text-[var(--font-size-sm)] leading-none text-sharp cursor-pointer"
            >
              GitHub
            </Link>
            <Link
              href="https://www.linkedin.com/in/itsvnp/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--text)] hover:text-[var(--accent-color)] dark:hover:text-[var(--accent-color)] transition-colors text-[var(--font-size-sm)] leading-none text-sharp cursor-pointer"
            >
              LinkedIn
            </Link>
            <Link
              href="https://x.com/itsvnpandey"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--text)] hover:text-[var(--accent-color)] dark:hover:text-[var(--accent-color)] transition-colors text-[var(--font-size-sm)] leading-none text-sharp cursor-pointer"
            >
              X
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
} 